// extracted by mini-css-extract-plugin
module.exports = {"Sports":"Sports_Sports__31fi0","Overlay":"Sports_Overlay__2NxIg","Content":"Sports_Content__3byQw"};